

const CategoryColorsByTag = {
    'log_nutrition':'rgb(218,84,84)',
    'log_sleep':'rgb(153,54,239)',
    'log_weight':'rgb(103,190,40)',
    'log_workout':'rgb(255,117,30)',
}

const CategoryUtils = {
    getCategoryColor(key) {
        return CategoryColorsByTag[key];
    }


};

export default CategoryUtils;



// WEBPACK FOOTER //
// ./src/utils/CategoryUtils.js